module.exports = __webpack_public_path__ + "assets/img/WEI.0b9db8a6.jpg";